import { Container } from 'ui/container'
import { TasksList } from 'features/admin/tasks'
import { Link } from 'react-router-dom'
import { routes } from 'core/routes/paths'

import c from '../assets/sass/page.module.scss'

const AdminTasksPage = () => {
    return (
        <div className={c.component}>
            <div className={c.header}>
                <Link to={routes.admin} className={c.back}>
                    ← Назад
                </Link>
                <span className={c.title}>Управление заданиями</span>
            </div>
            <Container>
                <TasksList />
            </Container>
        </div>
    )
}

export default AdminTasksPage
